import React, { memo } from 'react';
import './Filters.css';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import useLocations from './hooks/useLocations';
import { useFiltersContext } from './hooks/useFiltersContext';
import { getUserSession } from '../../../../../util/core/Session';
import config from '../../../../../config/config';

const Filters = ({ className = '' }) => {
    const { filters, onFilterChange } = useFiltersContext();
    const session = getUserSession();
    const { data } = useLocations(filters?.cidade?.value);
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const locations = data || [];

    // Generate years array (current year and 5 years back)
    const currentYear = new Date().getFullYear();
    const yearsArray = Array.from({ length: 6 }, (_, i) => {
        const year = currentYear - i;
        return { value: year.toString(), label: year.toString() };
    });

    // Generate months array
    const monthsArray = [
        { value: '', label: 'Todos' },
        { value: '01', label: 'Jan' },
        { value: '02', label: 'Fev' },
        { value: '03', label: 'Mar' },
        { value: '04', label: 'Abr' },
        { value: '05', label: 'Mai' },
        { value: '06', label: 'Jun' },
        { value: '07', label: 'Jul' },
        { value: '08', label: 'Ago' },
        { value: '09', label: 'Set' },
        { value: '10', label: 'Out' },
        { value: '11', label: 'Nov' },
        { value: '12', label: 'Dez' }
    ];

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            {isAdm && (
                <MultipleSelect
                    label="Cidade"
                    options={[
                    { value: '', label: 'Todos' },
                        ...locations?.map((location) => ({
                            value: location.city_id,
                            label: location.cidade
                        }))
                    ]}
                    onChange={onFilterChange}
                    name="cidade"
                    className="select-cidade-dashboards h-50"
                    defaultValue={filters.cidade}
                />
            )}
            <MultipleSelect
                label="Ano"
                options={yearsArray}
                onChange={onFilterChange}
                name="ano"
                className="select-ano-dashboards h-50"
                defaultValue={filters.ano}
            />
            <MultipleSelect
                label="Competência"
                options={monthsArray}
                onChange={onFilterChange}
                name="mes"
                className="select-mes-dashboards h-50"
                defaultValue={filters.mes}
            />
        </div>
    );
};

export default memo(Filters);
